<span class="text-headline-6 font-medium">{{ 'mapFilter.filterComposition' | transloco }}</span>
<div
    class="flex mt-2 w-full mb-4"
    [class]="panelWidthTwoThird() ? '2xl:flex-row md:flex-col' : 'flex-col'">
    <mat-form-field
        appearance="outline"
        class="border-none text-base outline-none composition-input rounded-lg"
        [class]="panelWidthTwoThird() ? '2xl:w-4/5 2xl:mr-0 md:w-full md:mr-4' : 'w-full'">
        <input
            class="w-full"
            matInput
            type="text"
            [disabled]="isEditDisabled()"
            [formControl]="mapFilterCompositionService.compositionControl()"
            [placeholder]="compositionInputPlaceholder()" />
        <app-composition-attribute-filter-button matSuffix />
    </mat-form-field>

    <span
        class="text-subtitle-2 font-light text-on-surface"
        [class]="panelWidthTwoThird() ? '2xl:w-1/5 2xl:mt-2 2xl:ml-2 md:w-full md:mt-6' : 'w-full mt-6'"
        >{{ 'mapFilter.verifyCompositionValidity' | transloco }}</span
    >
</div>
@if (mapFilterCompositionService.failCompositionResult()?.length) {
    <div
        animate.enter="enter-animation"
        class="mt-4 overflow-hidden border-none rounded-lg p-4 bg-error-container"
        [style.--expand-duration]="'2s'">
        @for (result of mapFilterCompositionService.failCompositionResult(); track result) {
            <ul>
                <li class="text-base text-error">{{ `mapFilter.compositionError.${result}` | transloco }}</li>
            </ul>
        }
    </div>
}
